// Maps 0x571a6a108adb08f9ca54fe8605280F9EE0eD4AF6 -> 0x571a...eD4AF6
export const maskWalletAddress = (address: string) => address.replace(MaskRegExp, '$1...$2');

const MaskRegExp = /^(.{6}).*(.{6})$/;
